import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { WishlistBulkActions } from 'src/app/business/app-wishlist-box/constants/wishlist-filter.const';
import { BottomSheetService } from 'src/app/business/app-wishlist-box/services/bottomsheet.service';

@Component({
    selector: 'app-shared-confirmation-bottomsheet',
    templateUrl: './shared-confirmation-bottomsheet.component.html',
    styleUrls: ['./shared-confirmation-bottomsheet.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SharedConfirmationBottomsheetComponent {
    actionTypes = WishlistBulkActions;
    data: {
        type: WishlistBulkActions;
        title: string;
        primaryButtonTitle: string;
        secondaryButtonTitle?: string;
        primaryButtonSubtitle?: string;
        secondaryButtonSubtitle?: string;
        selectedButton?: string;
    };
    constructor(
        private readonly bottomSheetRef: MatBottomSheetRef<SharedConfirmationBottomsheetComponent>,
        private readonly bottomSheetService: BottomSheetService,
        private readonly cdRef: ChangeDetectorRef
    ) {}

    closeBottomSheet(actionType: string) {
        if(actionType){
            this.bottomSheetRef.dismiss(actionType);
        }
    }

    ngOnInit() {
        this.bottomSheetService.data$.subscribe({
            next: (d) => {
                this.data = d;
                this.cdRef.detectChanges();
            }
        });
    }
}
